import { createApp } from 'vue';
import AuthModal from './components/AuthModal.vue';

const app = createApp({
    components: { AuthModal }
});
app.mount('#header-auth');
